"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const config_1 = require("./config");
const index_1 = require("./id/index");
index_1.IkeId.getBytes = function (size) {
    var array = new Uint8Array(size);
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        crypto.getRandomValues(array);
        return array;
    }
    if (typeof msCrypto === 'object' && typeof msCrypto.getRandomValues === 'function') {
        msCrypto.getRandomValues(array);
        return array;
    }
    throw new Error('Unable to get Randomness');
};
config_1.IkeConfigStore.fetch = window.fetch;
tslib_1.__exportStar(require("./index"), exports);
//# sourceMappingURL=browser.js.map